import { Navigate, useParams } from 'react-router-dom'
import { HIDDEN_TOOL_PATHS } from '../config/hiddenTools'
import { useAuth } from '../context/AuthContext'
import { planBypassesLaunchScope } from '../config/planAccess'

// Blocks direct navigation to a tool route that's hidden pre-launch, even if
// the user has the URL. Bounces back to League Home instead of rendering the
// page — UNLESS the user has earned early access to this specific tool:
// either their plan bypasses launch scope (currently Elite — "first access"
// to every tool, see config/planAccess.js), or they unlocked this tool
// through the Founding Manager referral program (config/referralProgram.js,
// fetched onto the auth context from /api/referrals/me).
export default function HiddenRoute({ path, children }) {
  const { id } = useParams()
  const { plan, planLoading, referralUnlocks } = useAuth()

  // Wait for the real plan + referral perks before deciding, so an entitled
  // user doesn't get bounced for a flash while the defaults are still loading.
  if (planLoading) return null

  // Defensive default: a missing list must bounce to League Home, never crash
  // the page (every pre-launch tool showed "Something went wrong" on 11 Oct 2026).
  const earnedEarlyAccess = planBypassesLaunchScope(plan) || (referralUnlocks ?? []).includes(path)

  if (HIDDEN_TOOL_PATHS.includes(path) && !earnedEarlyAccess) {
    return <Navigate to={`/league/${id}`} replace />
  }

  return children
}
